import styled from "styled-components";

export const LoadingLogoImage = styled.img`
  max-width: 50%;
  max-height: 50%;
  margin: auto;
`;

export const LoadingText = styled.span`
  font-size: 1.5rem;
  color: dimgray;
  text-align: center;
  max-width: 80%;
  margin-bottom: 2rem;
  @media (max-width: 700px) {
    font-size: 1rem;
  }
`;